import PropTypes from 'prop-types';
import styles from './FJAudioTag.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJConstant from '../../../constants/FJConstant';
import classNames from 'classnames';

const TAG_CONFIG = {
    [FJConstant.AUDIO_TAG_TYPE_SFX]: {
        className: styles.blue,
        previewClassName: styles.preview_blue,
        text: 'sfx',
    },
    [FJConstant.AUDIO_TAG_TYPE_MUSIC]: {
        className: styles.pink,
        previewClassName: styles.preview_pink,
        text: 'mus',
    },
    [FJConstant.AUDIO_TAG_TYPE_INST]: {
        className: styles.green,
        previewClassName: styles.preview_green,
        text: 'inst',
    },
};

function FJAudioTag({ type, className, isPreview }) {
    const config = TAG_CONFIG[type];

    if (!config) return null;

    return (
        <div className={classNames(styles.box, config[isPreview ? 'previewClassName' : 'className'], className)}>
            {FJLocalStore._(config.text)}
        </div>
    );
}

FJAudioTag.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    isPreview: PropTypes.bool,
};

export default FJAudioTag;
